import { connect } from 'react-redux'
import AggregateDetails from '../../components/details/aggregate_details'
import { makeSelectAggregateDetailsData, selectIsManagerSite } from '../../selectors'

// Factory form: each expanded row gets its own memoized selector, so its
// sorted scorecard data keeps its reference across unrelated dispatches.
const makeMapStateToProps = () => {
  const selectAggregateDetailsData = makeSelectAggregateDetailsData();

  return (state, ownProps) => {
    const eventId = String(ownProps.eventId);
    const { detailsKey } = ownProps;
    const entry = state.details[eventId]?.[detailsKey];

    return {
      data: selectAggregateDetailsData(state, eventId, detailsKey),
      loading: entry?.loading || false,
      error: entry?.error || null,
      holeByHoleView: state.leaderboardV2.holeByHoleView,
      roundId: state.leaderboardV2.roundId,
      leagueId: state.leaderboardV2.leagueId,
      isManagerSite: selectIsManagerSite(state),
      playerProfilesEnabled: Boolean(state.leaderboardV2.playerProfilesEnabled),
    }
  };
};

export default connect(makeMapStateToProps)(AggregateDetails)
